import React, {useEffect, useRef} from "react";
import {Editor} from "@tinymce/tinymce-react";
import {checkNullStr, printError} from "../utils/ReactUtils";
import {Label} from "../index";

/**
 * Create a @tinymc based text-editor.
 *
 * It requires API-key which can be generated from here: {@link https://www.tiny.cloud/my-account/integrate/#react}
 *
 * Add new domains: {@link https://www.tiny.cloud/my-account/domains/}
 *
 * @example
 * const [editorText, setEditorText] = useState('Editor text');
 *    <TextEditor
 *         apiKey={'your-api-key'}
 *         id={'editor'}
 *         label={'Text Editor'}
 *         height={300}
 *         initialValue={undefined}
 *         value={editorText}
 *         required={false}
 *         labelColor={'black'}
 *         onChange={(content) => {
 *             setEditorText(content);
 *         }}
 *  />
 */
const TextEditor = React.memo(({
                                   labelClassName = '',
                                   apiKey,
                                   height = 300,
                                   value,
                                   id,
                                   initialValue,
                                   onChange,
                                   required,
                                   label = "",
                                   labelColor = '',
                                   labelStyle = {},
                               }) => {
    const TAG = "TextEditor";

    const editorRef = useRef(null);

    useEffect(() => {
        // try {
        //     const editorElement = getElement('tox-editor-container', 'class');
        //     printLog(TAG, 'useEffect.editorElement:', editorElement);
        //     if (editorElement) {
        //         editorElement.setAttribute('style', 'height', '100px');
        //         editorElement.setAttribute('style', 'max-height', '100px');
        //     }
        // } catch (error) {
        //     printError(TAG, error);
        // }
        // printLog(TAG, 'useEffect.value:', value);
    }, [value]);


    const log = () => {
        try {
            if (editorRef.current) {
                // printLog(TAG, editorRef.current.getContent());
            }
        } catch (error) {
            printError(TAG, error);
        }
    };
    const handleEditorChange = (content, editor) => {
        // printLog(TAG, 'handleEditorChange:Content was updated:', content);
        if (onChange) onChange(content);
    };
    return (
        <div className={'text-editor'}>
            {/*label*/}
            {checkNullStr(label) &&
                <Label className={`text-input-label px-2 m-0 p-0 pb-1 ${labelClassName}`} required={required}
                       color={labelColor} style={labelStyle}>{label}
                </Label>}

            <Editor
                className={'scroller scroller-y-auto'}
                apiKey={apiKey}
                value={value}
                initialValue={initialValue}
                onInit={(evt, editor) => {
                    editorRef.current = editor;
                    // printLog(TAG, 'Editor.onInit.evt:', evt, 'editor:', editor);
                }}
                onEditorChange={handleEditorChange}
                id={id}
                init={{
                    height: height,
                    menubar: true,
                    // plugins: [
                    //     "ai preview powerpaste casechange footnotes tinycomments searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed advtemplate codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount tinymcespellchecker mergetags a11ychecker editimage help formatpainter permanentpen pageembed charmap quickbars linkchecker emoticons advtable export mentions typography markdown importword",
                    // ],
                    toolbar: `undo redo | formatselect | importword | aidialog aishortcuts | blocks fontsizeinput | bold italic backcolor | align numlist bullist | link image | table media pageembed | lineheight  outdent indent | strikethrough forecolor backcolor removeformat | charmap emoticons checklist | code fullscreen preview | save print export | pagebreak anchor codesample footnotes mergetags | addtemplate inserttemplate | addcomment showcomments | ltr rtl casechange | spellcheckdialog a11ycheck`,
                    // importword_service_url: "add.url.here",
                    templates: [],
                    // content_style:                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                }}
            />
            {/*<button onClick={log}>Log editor content</button>*/}
        </div>
    );
});

export default TextEditor;
